module.exports = __webpack_public_path__ + "img/store.77eca467.png";